<ng-container *transloco="let t; read: 'documents.list'">
  @if (!dataSource.isDataSourceNotFound) {
    <form>
      @if (!options.isDashboardLocked) {
        <div class="document-list__control-wrapper" [class.hidden]="!dataSource.page?.items">
          @if (options.widgetPayload?.isCardView) {
            <mat-checkbox
              [checked]="!!(selectedDocuments | isChecked: pageCount)?.checked"
              [indeterminate]="!!(selectedDocuments | isChecked: pageCount)?.indeterminate"
              (change)="selectAllDocuments($event.checked)"
            ></mat-checkbox>
          }
          <xi-search-box
            [placeholder]="t('enter-text-to-search')"
            [(ngModel)]="activeUserQuery"
            [isFiredOnEnter]="true"
            [status]="activeUserQueryStatus"
            [hasOutline]="true"
            [stretch]="true"
            textSize="small"
            (onCancelClick)="clearDocumentSearch()"
            (onChangeOverride)="onSearchDocumentsByQuery()"
            ngDefaultControl
            name="document-search"
          ></xi-search-box>
          @if (!options.widgetPayload?.isCardView) {
            <div class="toggle-switch">
              <xi-toggle-switch
                [leftText]="t('summary')"
                [rightText]="t('full-text')"
                [color]="'orca'"
                [side]="left"
                size="xxlarge"
                changeColorOnToggle="false"
                [isToggled]="isTableViewToggled"
                (onToggle)="isTableViewToggled = $event.detail.isToggled"
              >
              </xi-toggle-switch>
            </div>
          }
          @if (showDocumentActions && options.widgetPayload?.isCardView) {
            <ng-container *ngTemplateOutlet="documentActions"></ng-container>
          }
        </div>
      }
      @if (showSelectCount && !showSelectAll) {
        <div
          [ngClass]="
            !options.widgetPayload?.isCardView
              ? 'document-list__selection-header'
              : 'document-list__selection-card-header'
          "
        >
          <p>
            {{ t('numberof-documents-selected', { count: selectedDocuments.length }) }}
          </p>
          @if (showDocumentActions && !options.widgetPayload?.isCardView) {
            <ng-container *ngTemplateOutlet="documentActions"></ng-container>
          }
        </div>
      }
      @if (showSelectAll) {
        <div
          [ngClass]="
            !options.widgetPayload?.isCardView
              ? 'document-list__selection-header'
              : 'document-list__selection-card-header'
          "
        >
          <p>
            {{ t('all-documents-on-page-selected', { count: selectedDocuments.length }) }}
            <a (click)="selectAllInSearch()">{{ t('select-all-documents') }}</a>
          </p>
          @if (showDocumentActions && !options.widgetPayload?.isCardView) {
            <ng-container *ngTemplateOutlet="documentActions"></ng-container>
          }
        </div>
      }
      @if (allSearchDocumentsSelected) {
        <div
          [ngClass]="
            !options.widgetPayload?.isCardView
              ? 'document-list__selection-header'
              : 'document-list__selection-card-header'
          "
        >
          <p>
            {{ t('all-documents-in-search-selected') }}
            <a (click)="selectAllDocuments(false)">{{ t('clear-selection') }}</a>
          </p>
          @if (showDocumentActions && !options.widgetPayload?.isCardView) {
            <ng-container *ngTemplateOutlet="documentActions"></ng-container>
          }
        </div>
      }
    </form>
  }

  <div class="table-wrapper">
    @if (dataSource?.loading$ | async) {
      <div class="loading">
        <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
      </div>
    }
    @if (dataSource?.isDataSourceNotFound) {
      <div class="text-center">
        <h1>{{ t('data-source-removed-select-another') }}</h1>
      </div>
    }
    @if (!dataSource?.isDataSourceNotFound && dataSource?.page.count === 0) {
      <div class="text-center">
        <h1>{{ t('no-documents-found') }}</h1>
      </div>
    }
    @if (!options.widgetPayload?.isCardView && otherFields.length) {
      <table
        mat-table
        [dataSource]="dataSource"
        (matSortChange)="onSort($event)"
        matSort
        matSortDisableClear
        [matSortActive]="sortProp"
        [matSortDirection]="sortOrder | lowercase"
        [class.hidden]="dataSource.isDataSourceNotFound || !dataSource.page?.count"
      >
        <tr mat-header-row *matHeaderRowDef="dataSource.displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: dataSource.displayedColumns"
          [class.table-row--inactive]="options.widgetPayload?.isClickOpenDocument === false"
        ></tr>

        <ng-container matColumnDef="docSelect">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              [checked]="!!(selectedDocuments | isChecked: pageCount)?.checked"
              [indeterminate]="!!(selectedDocuments | isChecked: pageCount)?.indeterminate"
              (change)="selectAllDocuments($event.checked)"
              class="table-view-checkbox"
            ></mat-checkbox>
          </th>

          <td mat-cell *matCellDef="let document">
            <mat-checkbox
              [checked]="isSelectedDocument(document)"
              (change)="selectDocument(document, $event.checked)"
            ></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="text">
          <th mat-header-cell *matHeaderCellDef="let document" class="text">
            <hr />
            @if (isTableViewToggled) {
              {{ columnLabelFor(getTextColumn('text')) }}
            } @else {
              {{ t('summary') }}
            }
          </th>
          <td
            mat-cell
            *matCellDef="let document"
            [class.mat-column-text--expanded]="!isTableViewToggled"
            (click)="openDocument(document)"
          >
            @if (isTextfieldDisplayed('text')) {
              @if (!isTableViewToggled) {
                <p>
                  {{ document.analyses[0].redactedSummary || document.summary || t('no-summary') }}
                </p>
              } @else {
                @if (document.sectioned) {
                  @for (item of document.analyses[0].flatSections; track item) {
                    <div class="document-section">
                      @if (document.title) {
                        <p class="document-section-title">{{ document.title }}</p>
                      }
                      <p class="document-section-name">
                        {{
                          item
                            | collectionSectionSeparator
                              : collectionResponse?.sectionSeparator?.label
                        }}
                      </p>
                      @if (item.value) {
                        <p class="document-section-value">{{ item.value }}</p>
                      }
                    </div>
                  }
                } @else {
                  @if (isTextfieldDisplayed('title')) {
                    <p class="document-section-title">
                      @if (!document.title) {
                        <span class="no-title">{{ t('no-title') }}</span>
                      }
                      {{ document.title }}
                    </p>
                  }
                  <p>
                    {{ documentText(document) }}
                  </p>
                }
              }
            }
            @if (isTextfieldDisplayed('abstract')) {
              <p>
                {{ t('abstract') }}:
                {{ document.abstract }}
              </p>
            }
          </td>
        </ng-container>

        @for (coldef of otherFields; track coldef) {
          <ng-container [matColumnDef]="coldef.columnId">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [disabled]="!coldef.sortable"
              [class.column-unavailable]="!coldef.available"
              [ngClass]="'column-type-' + coldef.type"
              matTooltipPosition="left"
              [matTooltip]="!coldef.available ? t('no-data-available') : undefined"
            >
              <hr />
              {{ columnLabelFor(coldef) }}
            </th>
            <td
              mat-cell
              *matCellDef="let document"
              [ngClass]="'column-type-' + coldef.type"
              (click)="openDocument(document)"
            >
              @switch (coldef.type) {
                @case ('id') {
                  <div
                    [matTooltip]="
                      document.id && document.id.toString().length > 10 ? document.id : ''
                    "
                    matTooltipPosition="above"
                  >
                    {{ document.id | truncate: 10 }}
                  </div>
                }
                @case ('sentiment') {
                  <app-sentiment-display
                    [sentimentScale]="options.sentimentScale"
                    [sentimentDisplay]="options.sentimentDisplay"
                    [sentimentRanges]="sentimentRanges"
                    [document]="document"
                    [isTableView]="true"
                  ></app-sentiment-display>
                }
                @case ('date') {
                  @for (content of getCellContent(coldef, document); track content) {
                    {{ content | lexDate }}
                  }
                }
                @case ('number') {
                  @for (content of getCellContent(coldef, document); track content) {
                    {{ content | number: coldef.pipeParams }}
                  }
                }
                @default {
                  @for (content of getCellContent(coldef, document); track content) {
                    <div [matTooltip]="content">
                      {{ content }}
                    </div>
                  }
                }
              }
            </td>
          </ng-container>
        }
      </table>
    } @else {
      <span class="experience-card-condensed">
        @for (item of dataSource.page.items; track item) {
          <div class="experience-card-condensed-view">
            <xi-condensed-experience-card
              [comment]="item | experienceCardComments"
              [promptLabel]="item.title ?? ''"
              [title]="
                dataSource.displayedColumns
                  | experienceCardTitle
                    : { sentiment: t('sentiment-score'), document: t('document') }
              "
              [bannerSentiment]="
                item
                  | experienceCardSentiment
                    : dataSource.displayedColumns
                    : options.sentimentScale
                    : sentimentRanges
              "
              [maxCommentLineCount]="5"
              [dropdownDirection]="10"
              [hasAttachments]="false"
              [isInteractable]="false"
              [isOverdue]="false"
              [isTruncated]="false"
              [isSelectable]="true"
              [iconButtons]="documentQuickActions | cardViewQuickActions: item"
              [selected]="item | experienceCardCheckbox: selectedDocuments"
              [localization]="{ details: t('show-document') }"
              [meta]="item | experienceCardMetaData: options : dataSource.displayedColumns"
              [metaIcon]="false"
              [titleScore]="item | titleScore: dataSource.displayedColumns"
              [titleSentiment]="
                item
                  | experienceCardSentiment
                    : dataSource.displayedColumns
                    : options.sentimentScale
                    : sentimentRanges
              "
              [titleIconOrSvg]="
                item
                  | experienceCardSentiment
                    : dataSource.displayedColumns
                    : options.sentimentScale
                    : sentimentRanges
                    : true
              "
              [ngClass]="{
                'sentiment-3': options.sentimentScale === 3,
                'sentiment-5': options.sentimentScale === 5,
              }"
              [showViewDetails]="options.widgetPayload?.isClickOpenDocument"
              (onCardClick)="openDocument(item)"
              (onSelectedChange)="selectDocument(item, $event.detail.event.target.checked)"
            >
            </xi-condensed-experience-card>
          </div>
        }
      </span>
    }
  </div>

  <mat-paginator
    [disabled]="(dataSource?.loading$ | async) || !dataSource?.page.count"
    [length]="dataSource?.page.count"
    [hidePageSize]="options.isDashboardLocked"
    [pageSize]="limit"
    [pageSizeOptions]="[20, 50, 100]"
    class="document-list__paginator-control"
    [class.hidden]="dataSource.isDataSourceNotFound || !dataSource.page?.items"
  ></mat-paginator>

  <ng-template #documentActions>
    @for (action of bulkQuickActions; track action.id) {
      <div class="document-list__submit-control quick-actions__layout">
        <xi-icon-button
          [icon]="action.icon"
          color="CX"
          [tooltip]="{ text: action.title }"
          (onClick)="onQuickActionClick(action)"
        ></xi-icon-button>
      </div>
    }
  </ng-template>
</ng-container>

@if (showDocumentViewModal) {
  <app-lex-xi-modal
    [isVisible]="showDocumentViewModal"
    [canBackdropClose]="false"
    maxWidth="80vw"
    (close)="onDocumentViewModalClosed($event)"
  >
    <ng-template appXIModalContent>
      @if (showDocumentViewModal) {
        <app-document-view-dialog
          [options]="documentViewModalOptions"
          (modalClosed)="onDocumentViewModalClosed($event)"
        ></app-document-view-dialog>
      }
    </ng-template>
  </app-lex-xi-modal>
}
@if (showAddDocumentTagsModal) {
  <app-lex-xi-modal
    [isVisible]="showAddDocumentTagsModal"
    [canBackdropClose]="false"
    maxWidth="600px"
    (close)="tagSelectedDocumentsAction()"
  >
    <ng-template appXIModalContent>
      @if (showAddDocumentTagsModal) {
        <app-add-tags-dialog
          [options]="documentTagsModalOptions"
          (modalClosed)="tagSelectedDocumentsAction({ action: 'ADD', tags: $event })"
        ></app-add-tags-dialog>
      }
    </ng-template>
  </app-lex-xi-modal>
}
@if (showRemoveDocumentTagsModal) {
  <app-lex-xi-modal
    [isVisible]="showRemoveDocumentTagsModal"
    [canBackdropClose]="false"
    maxWidth="600px"
    (close)="tagSelectedDocumentsAction()"
  >
    <ng-template appXIModalContent>
      @if (showRemoveDocumentTagsModal) {
        <app-remove-tags-dialog
          [options]="documentTagsModalOptions"
          (modalClosed)="tagSelectedDocumentsAction({ action: 'REMOVE', tags: $event })"
        ></app-remove-tags-dialog>
      }
    </ng-template>
  </app-lex-xi-modal>
}
